import type { IUsageFeeBill } from '../types/usage-fee-bill';
import type { IUsageFeeCurrent } from '../types';

import { create } from 'zustand';

export interface IUsageFeeBillStoreState {
  usageFeeBills?: IUsageFeeBill[];
  usageFeeBillFails?: IUsageFeeBill[];
  usageFeeBillPaymentFails?: IUsageFeeBill[];
  usageFeeCurrent?: IUsageFeeCurrent;
  isHasUsageFeeBill: boolean;
}

export interface IUsageFeeBillStoreActions {
  setUsageFeeBills: (value: IUsageFeeBill[]) => void;
  setUsageFeeBillFails: (value: IUsageFeeBill[]) => void;
  setUsageFeeBillPaymentFails: (value: IUsageFeeBill[]) => void;
  setUsageFeeBillsNext: (value: IUsageFeeBill[]) => void;
  setUsageFeeCurrent: (value?: IUsageFeeCurrent) => void;
  setIsHasUsageFeeBill: (value: boolean) => void;
}

export const useUsageFeeBillStore = create<IUsageFeeBillStoreState & IUsageFeeBillStoreActions>()(
  (set) => ({
    usageFeeBills: undefined,
    usageFeeCurrent: undefined,
    isHasUsageFeeBill: false,
    usageFeeBillPaymentFails: undefined,

    setUsageFeeBills: (val: IUsageFeeBill[]) => {
      set(() => ({ usageFeeBills: val }));
    },
    setUsageFeeBillFails: (val: IUsageFeeBill[]) => {
      set(() => ({ usageFeeBillFails: val }));
    },
    setUsageFeeBillPaymentFails: (val: IUsageFeeBill[]) => {
      set(() => ({ usageFeeBillPaymentFails: val }));
    },
    setUsageFeeBillsNext: (val: IUsageFeeBill[]) => {
      set((state) => ({ usageFeeBills: [...(state.usageFeeBills || []), ...val] }));
    },
    setUsageFeeCurrent: (val?: IUsageFeeCurrent) => {
      set(() => ({ usageFeeCurrent: val }));
    },
    setIsHasUsageFeeBill: (val: boolean) => {
      set(() => ({ isHasUsageFeeBill: val }));
    },
  }),
);
